var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "entries-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                staticClass:
                  "contactum_filter_form_select contactum-input-s1 w-100",
                attrs: { filterable: "" },
                on: { change: _vm.onchangeForm },
                model: {
                  value: _vm.form_id,
                  callback: function($$v) {
                    _vm.form_id = $$v
                  },
                  expression: "form_id"
                }
              },
              _vm._l(_vm.forms, function(item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: item.id }
                })
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "entries-header" }, [
        _c(
          "div",
          [
            _c("el-input", {
              attrs: {
                clearable: "",
                filterable: "",
                placeholder: "Search Entries",
                "prefix-icon": "el-icon-search"
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.fetchEntries()
                }
              },
              model: {
                value: _vm.search,
                callback: function($$v) {
                  _vm.search = $$v
                },
                expression: "search"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("DateFilter", {
              attrs: { filter_date_range: _vm.filter_date_range },
              on: {
                "update:filter_date_range": function($event) {
                  _vm.filter_date_range = $event
                },
                "date-filter-changed": _vm.onDateFilterChanged
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("EntriesTable", {
        attrs: { "paginated-data": _vm.paginatedData, form: _vm.form_id }
      }),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "contactum_pagination",
        attrs: {
          background: "",
          "current-page": _vm.paginate.current_page,
          "page-sizes": [5, 10, 20, 50, 100],
          "page-size": parseInt(_vm.paginate.per_page),
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.paginate.total
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.goToPage,
          "update:currentPage": function($event) {
            return _vm.$set(_vm.paginate, "current_page", $event)
          },
          "update:current-page": function($event) {
            return _vm.$set(_vm.paginate, "current_page", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h2", [_vm._v("Entries")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }